export const faqData = [
  {
    id: 1,
    question:
      "What is the maximum loan tenure available for a home loan with Axis Bank?",
    answer:
      "Axis Bank offers home loan tenures of up to 30 years, based on the applicant’s age and loan eligibility.",
  },
  {
    id: 2,
    question:
      "Does the EMI Calculator show the exact processing fees and other charges?",
    answer:
      "The Axis Bank Home Loan EMI Calculator estimates the EMI based on the loan amount, interest rate, and tenure. However, processing fees and other charges may vary, so you should consult with the bank for the exact details.",
  },
  {
    id: 3,
    question:
      "Can I adjust my loan amount or tenure after calculating the EMI?",
    answer:
      "Yes, you can modify the loan amount, interest rate, or tenure to see how it impacts your EMI and total repayment. This flexibility allows you to choose the most suitable loan configuration for your financial situation.",
  },
  {
    id: 4,
    question:
      "Does Axis Bank charge a prepayment fee if I pay off my loan early?",
    answer:
      "Axis Bank generally charges a prepayment fee for home loans, which can vary based on the type of loan you have. You can inquire with the bank to get the exact prepayment terms.",
  },
];
